export const siteConfig = {
  // ── Site ────────────────────────────────────────────────────────────────────
  url:      normalizeSiteUrl(process.env.NEXT_PUBLIC_SITE_URL),

  // ── Analytics ───────────────────────────────────────────────────────────────
  gtmId:              process.env.NEXT_PUBLIC_GTM_ID                        || "GTM-NFZ9GC23",
  googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION      || "3-6fvDzxCBorWlx5xwQznOvUt6dEX_jmQ86b-tQJNPw",

  // ── Primary contact ─────────────────────────────────────────────────────────
  phone:    process.env.NEXT_PUBLIC_COMPANY_PHONE     || "+1 (516) 717 2049",
  phoneTel: process.env.NEXT_PUBLIC_COMPANY_PHONE_TEL || "+15167172049",
  email:    process.env.NEXT_PUBLIC_COMPANY_EMAIL     || "reachus@velanapps.com",

  // ── Additional emails ───────────────────────────────────────────────────────
  emailInfo:    process.env.NEXT_PUBLIC_EMAIL_INFO    || "info@velaninfo.com",
  emailSupport: process.env.NEXT_PUBLIC_EMAIL_SUPPORT || "support@velanapps.com",
  emailDpo:     process.env.NEXT_PUBLIC_EMAIL_DPO     || "dpo@velaninfo.com",

  // ── India office phones ──────────────────────────────────────────────────────
  phoneIndia1:    process.env.NEXT_PUBLIC_PHONE_INDIA_1     || "+91 422 495 4666",
  phoneIndia1Tel: process.env.NEXT_PUBLIC_PHONE_INDIA_1_TEL || "+914224954666",
  phoneIndia2:    process.env.NEXT_PUBLIC_PHONE_INDIA_2     || "+91 7358257333",
  phoneIndia2Tel: process.env.NEXT_PUBLIC_PHONE_INDIA_2_TEL || "+917358257333",

  // ── Office addresses ────────────────────────────────────────────────────────
  addressUSA: {
    street:       "8 The Green, Suite 300",
    cityStateZip: "Dover, DE 19901, USA",
    city:         "Dover",
    region:       "DE",
    postalCode:   "19901",
    countryCode:  "US",
    mapUrl:       "https://maps.app.goo.gl/f1xtdKnbzhx4h6sQA",
  },
  addressIndia: {
    lines: ["A1, Harsha Garden", "Masakalipalayam Road", "Uppilipalayam,", "Coimbatore - 641015, INDIA"],
    mapUrl: "https://maps.app.goo.gl/8uiJ1H37x7r2FUyx6",
  },

  // ── Social media ────────────────────────────────────────────────────────────
  social: {
    facebook:  process.env.NEXT_PUBLIC_SOCIAL_FACEBOOK  || "https://www.facebook.com/VelanApps",
    twitter:   process.env.NEXT_PUBLIC_SOCIAL_TWITTER   || "https://x.com/VelanApps",
    linkedin:  process.env.NEXT_PUBLIC_SOCIAL_LINKEDIN  || "https://www.linkedin.com/company/velanapps/",
    pinterest: process.env.NEXT_PUBLIC_SOCIAL_PINTEREST || "https://www.pinterest.com/velanapp",
    instagram: process.env.NEXT_PUBLIC_SOCIAL_INSTAGRAM || "https://www.instagram.com/velanapps/",
  },

  // ── External services ────────────────────────────────────────────────────────
  geoIpEndpoint: process.env.GEOIP_ENDPOINT || "https://ipwho.is",

  defaultOgImage: {
    url: "/images/og-default.webp",
    width: 1200,
    height: 630,
    alt: "VelanApps — Custom Software Development Company",
  },
};

// Guards against an env value without a scheme (e.g. "staging.example.com"):
// Next.js would treat it as a relative path and prefix metadataBase, producing
// URLs like https://velanapps.com/staging.example.com/blog/...
function normalizeSiteUrl(url) {
  const value = url?.trim();
  if (!value) return "https://velanapps.com";
  return (/^https?:\/\//i.test(value) ? value : `https://${value}`).replace(/\/+$/, "");
}

// Canonical for a blog post / case study. Always derived from the current site
// URL — the canonicalUrl stored on the post was auto-filled with whichever
// environment (dev/staging) it was saved on, so it can't be trusted.
export function postCanonicalUrl(section, slug) {
  return `${siteConfig.url}/${section}/${slug}`;
}

export function normalizeCanonical(url) {
  return url.replace(/(?<!:\/)\/+$/, "");
}

const PRODUCTION_HOSTS = new Set(["velanapps.com", "www.velanapps.com"]);

function isProductionHost(url) {
  try {
    return PRODUCTION_HOSTS.has(new URL(url).hostname);
  } catch {
    return false;
  }
}

export const isLiveSite = isProductionHost(siteConfig.url);
